import { MP_ALIAS_COBRANZAS } from '../monetizacion/vendedorNiveles.js';
import { escapeHtml as esc } from './escapeHtml.js';
import { mlvApplyZ } from './mlvZLayers.js';
import { mlvSaveFocus } from './mlvFocusRestore.js';
import { mlvModalHistoryAttach } from '../navigation/mlvModalHistoryBridge.js';

/**
 * Modal informativo: alias de Mercado Pago para regularizar comisiones (sin integración API aún).
 */
export function openMercadoPagoAliasModal({ alias = MP_ALIAS_COBRANZAS } = {}) {
  const restoreFocus = mlvSaveFocus();
  const prev = document.getElementById('mlv-mp-alias-modal');
  if (prev) prev.remove();

  const wrap = document.createElement('div');
  wrap.id = 'mlv-mp-alias-modal';
  wrap.className =
    'fixed inset-0 flex items-end justify-center sm:items-center bg-black/50 p-4';
  mlvApplyZ(wrap, 'mercadoPago');
  wrap.setAttribute('role', 'dialog');
  wrap.setAttribute('aria-modal', 'true');
  wrap.setAttribute('aria-labelledby', 'mlv-mp-alias-title');

  wrap.innerHTML = `
    <div class="w-full max-w-md rounded-t-3xl bg-white p-6 shadow-2xl sm:rounded-3xl">
      <h2 id="mlv-mp-alias-title" class="font-heading text-lg font-bold text-slate-900">Regularizar comisión</h2>
      <p class="mt-2 text-sm leading-relaxed text-slate-600">
        Transferí el monto pendiente al <strong class="font-semibold text-slate-800">alias</strong> de abajo. Cuando lo registremos, podés volver a publicar con normalidad. Después tocá <strong class="font-semibold text-slate-800">Ya regularicé</strong> en Mis publicaciones.
      </p>
      <div class="mt-4 rounded-2xl bg-brand-primary/10 px-4 py-3 text-center">
        <p class="text-xs font-semibold uppercase tracking-wide text-slate-500">Alias</p>
        <p class="mt-1 font-mono text-xl font-bold text-brand-primary select-all">${esc(alias)}</p>
      </div>
      <button type="button" id="mlv-mp-alias-close" class="mt-6 w-full rounded-full bg-brand-primary py-3.5 text-sm font-bold text-white shadow-md transition hover:brightness-95">
        Entendido
      </button>
    </div>
  `;

  const hist = mlvModalHistoryAttach(() => {
    try {
      restoreFocus();
    } catch (_e) {
      /* ignore */
    }
    wrap.remove();
    document.removeEventListener('keydown', onKey);
  });

  function close() {
    hist.closeFromUi();
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  wrap.addEventListener('click', (e) => {
    if (e.target === wrap) close();
  });
  wrap.querySelector('#mlv-mp-alias-close').onclick = close;
  document.addEventListener('keydown', onKey);
  document.body.appendChild(wrap);
  requestAnimationFrame(() =>
    wrap.querySelector('#mlv-mp-alias-close')?.focus?.({ preventScroll: true })
  );
}
